// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__26tqO","loaderOuter":"PageOverlayLoader_loaderOuter__2mu9S"};